import React, { useCallback, useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { CountryCode } from '@carsys/enums/country-code'
import { AccountType, ISearchResultAccount, ResultObjectType } from '@cbgms/api'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { addressFormatters } from '@cbgms/base/utils/address'
import { ResultTitle } from './Title'
import FullName from '@cbgms/components/src/utils/FullName'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%'
    },
    pointer: {
      cursor: 'pointer'
    },
    button: {
      textTransform: 'none'
    }
  })
)

export interface IAccountResult {
  VisitorCity: string
  VisitorPostalCode: string
  VisitorHouseNumberAddition: string
  VisitorHouseNumber: string
  UUID: string
  FirstName: string
  Name: string
  NamePrefix: string
  VisitorAddress: string
  CompanyName: string
  Type?: AccountType
}

export interface AccountResultType {
  hasGroupHeader: boolean
  Type: ResultObjectType
  Account: ISearchResultAccount
  clearQuery: () => void
  primaryAction: () => Promise<void>
}

export const AccountResult: React.FC<AccountResultType> = props => {
  const { Account, Type, hasGroupHeader, primaryAction } = props
  const classes = useStyles()
  const { country } = useContext(LocaleContext)
  const formatter = addressFormatters[country] || addressFormatters[CountryCode.NL]
  const addressLine = formatter.formatAddressStreet(Account)
  const postalLine = formatter.formatAddressCity(Account, 'Postal')
  const handleOpenAcountClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12} className={classes.pointer} onClick={handleOpenAcountClick}>
          <Grid container spacing={0}>
            <ResultTitle resultType={Type} isTitleVisible={!hasGroupHeader} />
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
                {Account.Type !== AccountType.Private && Account.CompanyName}
                {Account.Type === AccountType.Private && (
                  <FullName firstName={Account.FirstName} lastName={Account.Name} prefix={Account.NamePrefix} />
                )}
              </Typography>
              <Typography component='p'>
                {Account.Type !== AccountType.Private && (
                  <FullName firstName={Account.FirstName} lastName={Account.Name} prefix={Account.NamePrefix} />
                )}
                {addressLine}
                {postalLine}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
